import { fansupportPublic } from "../index";

export const getCampaignOrganisations = async () => {
    return fansupportPublic.get('campaign/organisations')
};